const createTrackingCookie = (name: string, value?: string): string => {
  const cookieExist =
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

  if (cookieExist) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`))
      ?.split("=")[1];
    return cookieValue!;
  } else {
    const newCookieValue = value ? value : crypto.randomUUID();
    const currentDate = new Date();
    const expirationDate = currentDate.setFullYear(
      currentDate.getFullYear() + 1
    );

    document.cookie = `${name}=${newCookieValue};expires=${new Date(
      expirationDate
    ).toUTCString()}`;
    return newCookieValue;
  }
};
export default createTrackingCookie;
